import { RequestService } from '../../../../../common/services/RequestService';
import { ENGINE_TYPES_GET } from '../../constants';

export const getEngineTypesRequest = payload => {
  return RequestService.get(ENGINE_TYPES_GET);
};
